export default __webpack_public_path__ + "static/wind02-da448ca4cf3a449d00b67a0698a8341d.jpg";